import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const deleteStep = async ({ stepId, caseId }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deletestep&companyid=${user.companyid}&teststepid=${stepId}&testcaseid=${caseId}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response;
};

const useDeleteStepQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteStep,
    onSuccess: () => {
      queryClient.invalidateQueries(["testCaseList"]);
    },
    onError: (error) => {
      console.log("Error uploading file", error.message);
    },
  });
};

export default useDeleteStepQuery;
